import { Component, OnInit, inject, ChangeDetectionStrategy } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Polyline } from "leaflet";
import { LorenEntityFormModel } from "../../../../shared/modules/loren-entity-form-card/interfaces/loren-entity-form-model.interface.ts";
import { LorenAsset } from "../../../loren-assets/interfaces/loren-asset.interface";
import { LorenFieldTypes } from "../../../../shared/modules/loren-entity-form-card/enums/loren-field-types.enum";
import { LorenColorService } from "../../../../shared/services/loren-color-service/loren-color.service";

@Component({
    selector: "loren-trace-color-selector-dialog",
    templateUrl: "./loren-trace-color-selector-dialog.component.html",
    styleUrls: ["./loren-trace-color-selector-dialog.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LorenTraceColorSelectorDialogComponent implements OnInit {
  data = inject<{
    selectedAssetsForTracing: LorenAsset[];
    assetTraceMap: Map<number, Polyline>;
}>(MAT_DIALOG_DATA);
  private dialogRef = inject<MatDialogRef<LorenTraceColorSelectorDialogComponent>>(MatDialogRef);

  formModel: LorenEntityFormModel;
  selectedAssetsForTracing: LorenAsset[] = [];

  private assetTraceMap: Map<number, Polyline> = new Map<number, Polyline>();

  constructor() {
    const data = this.data;

    this.selectedAssetsForTracing = data.selectedAssetsForTracing;
    this.assetTraceMap = data.assetTraceMap;
  }

  ngOnInit(): void {
    this.formModel = this.prepareAssetColorSelectorForm();
  }

  continue() {
    this.dialogRef.close({
      selectedColors: this.formModel.formFields.map((x) => x.value),
    });
  }

  private prepareAssetColorSelectorForm() {
    const formModel: LorenEntityFormModel = {
      formFields: [],
      formName: "",
    };

    this.selectedAssetsForTracing.forEach((asset, index) => {
      const color = this.assetTraceMap.has(asset.id)
        ? this.assetTraceMap.get(asset.id).options.color
        : LorenColorService.getColor(this.assetTraceMap.size + index);

      formModel.formFields.push({
        name: `color${index}`,
        label: "operations.color_select_for_asset",
        labelOptions: { value: asset.name },
        value: color,
        formControlType: LorenFieldTypes.COLOR,
      });
    });

    return formModel;
  }
}
